__webpack_require__.p = "/k8s_training_web/";